import Avatar from '../Avatar';
import AuthNav from '../navigation/AuthNav';
import { cn } from '../../lib/helpers.ts';

export default function Sidebar({ className }: { className?: string }) {
    return (
        <>
            <aside
                className={cn(
                    'flex',
                    'fixed h-screen w-56 flex-col bg-base-100 px-6 py-9',
                    className
                )}
            >
                <Avatar />

                <AuthNav />
            </aside>
        </>
    );
}
